import { useTranslation } from 'react-i18next';
import { cn } from 'shared/utils/cn';

export interface FilterPillsProps {
  filters: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}

export function FilterPills({ filters, activeFilter, onFilterChange }: FilterPillsProps) {
  const { t } = useTranslation('episodes');

  return (
    <fieldset className="flex flex-wrap items-center gap-4 px-4 py-6 bg-surface-container-low rounded-xl border-none">
      <legend className="sr-only">{t('filter.legend')}</legend>
      {filters.map((filter) => {
        const isActive = filter === activeFilter;
        return (
          <label
            key={filter}
            className={cn(
              'px-6 py-2 rounded-full text-sm font-medium transition-all hover:scale-105 cursor-pointer',
              'has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-tertiary has-[:focus-visible]:ring-offset-2',
              isActive
                ? 'bg-tertiary text-on-tertiary'
                : 'text-on-surface-variant border border-outline-variant/20 hover:text-tertiary',
            )}
          >
            <input
              type="radio"
              name="episode-filter"
              value={filter}
              checked={isActive}
              onChange={() => onFilterChange(filter)}
              className="sr-only"
            />
            {filter}
          </label>
        );
      })}
    </fieldset>
  );
}
